import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { addUserToGroup } from '../../services/GroupsService';
import { Group, AddUserToGroupRequest } from '../../types/Groups';

type Result = UseMutationResult<Group, Error, AddUserToGroupRequest>;

function useAddUserToGroup(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(addUserToGroup, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['groups', 'users'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useAddUserToGroup;
